import { Roboto_Mono } from "next/font/google"
import localFont from "next/font/local"

// Core fonts that need Next.js optimization
const roboto_mono = Roboto_Mono({
  display: "swap",
  preload: true,
  style: "normal",
  subsets: ["latin", "latin-ext"],
  variable: "--font-roboto",
  // 600 is the button weight of the new-community form (/form)
  weight: ["300", "400", "500", "600", "700"],
})

const blur = localFont({
  preload: true,
  src: [
    {
      path: "../public/assets/fonts/blur/Blur-Regular.ttf",
      weight: "400",
      style: "normal",
    },
    {
      path: "../public/assets/fonts/blur/Blur-Medium.otf",
      weight: "500",
      style: "normal",
    },
    {
      path: "../public/assets/fonts/blur/Blur-Bold.otf",
      weight: "700",
      style: "normal",
    },
  ],
  variable: "--font-blur",
})

// Export all font variables in an array for easy application
export const fontVariables = [roboto_mono.variable, blur.variable]
